import { render, staticRenderFns } from "./XPreview.vue?vue&type=template&id=0b997ed0&scoped=true&"
import script from "./XPreview.vue?vue&type=script&lang=js&"
export * from "./XPreview.vue?vue&type=script&lang=js&"
import style0 from "./XPreview.vue?vue&type=style&index=0&id=0b997ed0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b997ed0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
